import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

export interface BasketCalculationMutationPayload {
  id: number;
  quantity: number;
}

interface CalculationResponseItemType<T> {
  data: T;
}
export interface CalculationResponseType {
  totalAmount: number;
  totalAmountPayable: number;
  totalDiscount: number;
  totalShippingFee: number;
  taxPercent: number;
}

export type BasketCalculation = (
  payload: BasketCalculationMutationPayload[]
) => Promise<CalculationResponseItemType<CalculationResponseType>>;

const basketCalculation: BasketCalculation = async (payload) => {
  const client = new Client();
  return await client.post('/v1/Basket/Shopper/BasketCalculation', payload);
};

export const useBasketCalculation = () => {
  return useMutation({
    mutationFn: async (payload: BasketCalculationMutationPayload[]) =>
      await basketCalculation(payload),
    retry: 1,
  });
};
